<template>
<div class="row">
    <InputAmount
        :label="$t('label.bracketMin')"
        :number="min"
        :iso="defaultCurrency?.symbol"
        @amount="getMin"
        :required="true"
        containerClass="col-md-6"/>

    <InputAmount
        :label="$t('label.bracketMax')"
        :number="max"
        :iso="defaultCurrency?.symbol"
        @amount="getMax"
        :required="true"
        containerClass="col-md-6"/>
        <!-- <span v-if="error" class="fs-7 text-danger">{{ error }}</span> -->

</div>
</template>
<script setup>
import InputAmount from '@/components/InputAmount.vue';
import { ref, watch } from 'vue';
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore()

const error = ref(null)
const min = defineModel('min')
const max = defineModel('max')

const defaultCurrency = computed(() => store.getters['company/getCompanyCurrency']) ?? {symbol: "CFA"}

function getMin(amount){
    min.value = amount
}

function getMax(amount){
    max.value = amount
}

const validateMinMax = () => {
    error.value = '';

    if (min.value !== null && max.value !== null) {
        if (min.value > max.value) {
            error.value = i18n.global.t("label.rangeError");
        }
    }
    
    if (min.value <= 0 || max.value <= 0) {
        error.value = i18n.global.t("label.signedNumber");
    }
};

watch([min, max], validateMinMax);
</script>